import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Button, Icon, Modal, Grid, Input} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {isString} from 'lodash';

const {
  changeWtsDealerSelected,
  createWtsDealer,
  updateWtsDealer,
} = Actions;

const WtsDealerModal = ({mode, delerToEdit}) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const dealerSelected = useSelector((state) => state.wtsDealer.dealerSelected);
  
  const onChangeValues = (value, field) => {
    const changedSkillSelected = {...dealerSelected, [field]: isString(value) ? value.toUpperCase() : value};
    dispatch(changeWtsDealerSelected(changedSkillSelected));
  };

  const showCourseStatusModal = (e, value) => {
    e.preventDefault();
    setShowModal(value);
    if (mode === 'edit') {
      dispatch(changeWtsDealerSelected(delerToEdit));
    } else {
      dispatch(changeWtsDealerSelected(null));
    }
  };

  const saveDealer = (e) => {
    e.preventDefault();
    if (mode === 'new') {
      dispatch(createWtsDealer({'data': dealerSelected}));
    } else {
      dispatch(updateWtsDealer({'data': dealerSelected}));
    }
    showCourseStatusModal(e, false);
  };

  return (
    <Modal size='tiny' closeOnEscape={false} closeOnDimmerClick={false}
      open={showModal}
      trigger={
        mode === 'new' ?
          <Button compact content="Añadir"
            icon={<Icon name='add-circle' size='big' color='green' />}
            onClick={(e) => showCourseStatusModal(e, true)} /> :
          <Icon link name='pencil' size='big' onClick={(e) => showCourseStatusModal(e, true)} color='green' />
      }>
      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>
            {mode === 'new' ? 'Crear Concesionario' : 'Editar Concesionario'}
          </h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => showCourseStatusModal(e, false)} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <Grid stackable stretched>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="RUC"
                value={dealerSelected?.ruc || ''}
                disabled={!!dealerSelected?.ruc && mode !== 'new'}
                onChange={(e, {value}) => onChangeValues(value, 'ruc')}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="DESCRIPCIÓN"
                value={dealerSelected?.description || ''}
                disabled={false}
                onChange={(e, {value}) => onChangeValues(value, 'description')}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="NOMBRE CONTROL"
                value={dealerSelected?.control_name || ''}
                disabled={false}
                onChange={(e, {value}) => onChangeValues(value, 'control_name')}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="CÓDIGO"
                value={dealerSelected?.code || ''}
                disabled={false}
                onChange={(e, {value}) => onChangeValues(value, 'code')}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button positive compact icon='save' onClick={(e) => saveDealer(e)}>Guardar</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default WtsDealerModal;
